var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInterruptedByErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24,
    width: 24,
    id: "rect1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17,22 C 0,0 0,0 17,22 Z M 18,3 H 14.82 C 14.4,1.84 13.3,1 12,1 10.7,1 9.6,1.84 9.18,3 H 6 C 4.9,3 4,3.9 4,5 v 15 c 0,1.1 0.9,2 2,2 h 6.11 C 11.52,21.43 11.04,20.75 10.69,20 H 6 V 5 h 2 v 3 h 8 V 5 h 2 v 5.08 c 0.71,0.1 1.38,0.31 2,0.6 V 5 C 20,3.9 19.1,3 18,3 Z m -6,2 c -0.55,0 -1,-0.45 -1,-1 0,-0.55 0.45,-1 1,-1 0.55,0 1,0.45 1,1 0,0.55 -0.45,1 -1,1 z",
    id: "path1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2",
    transform: "translate(-0.01020408)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 24 V 24 H 0 Z",
    fill: "none",
    id: "path1-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 18.95727,15.489696 -1.3775,1.313371 -1.3775,-1.313371 -0.749913,0.715002 1.3775,1.31337 -1.3775,1.31337 0.749913,0.715003 1.3775,-1.313371 1.3775,1.313371 0.749914,-0.715003 -1.3775,-1.31337 1.3775,-1.31337 z m -1.3775,-3.042559 c -2.941149,0 -5.318534,2.266707 -5.318534,5.070931 0,2.804225 2.377385,5.070932 5.318534,5.070932 2.941149,0 5.318534,-2.266707 5.318534,-5.070932 0,-2.804224 -2.377385,-5.070931 -5.318534,-5.070931 z m 0,9.127677 c -2.345473,0 -4.254826,-1.820464 -4.254826,-4.056746 0,-2.236281 1.909353,-4.056745 4.254826,-4.056745 2.345473,0 4.254827,1.820464 4.254827,4.056745 0,2.236282 -1.909354,4.056746 -4.254827,4.056746 z",
    id: "path2",
    style: {
      strokeWidth: 0.519325
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterruptedByErrorIcon);
export default __webpack_public_path__ + "static/media/InterruptedByErrorIcon.97524716e93032dd8efeed05f6816609.svg";
export { ForwardRef as ReactComponent };